<template>
  <div style="height: inherit">
    <import />
    <!-- <filters
      :is-loaded="dataTableIsLoaded"
      @fetch-data="fetchData"
      :don-vis="donVis"
    /> -->
    <!-- <data-table
      :is-loaded="dataTableIsLoaded"
      :data-table="dataTable"
      :total-list="totalList"
      :data-meta="dataMeta"
      @update-pagination="pagination"
      @update-perpage="perpage"
      @update-searchquery="searchquery"
    /> -->
  </div>
</template>

<script>
/* eslint-disable */
import LayoutData from "@/layouts/LayoutData";
import { ref, computed, watch } from "@vue/composition-api";
import store from "@/store";
import { useRouter } from "@core/utils/utils";

import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {} from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";
import Import from "./components/Import";

import useSetup from "./useSetup";

export default {
  components: {
    Import,
  },
  data() {
    return {
      isWait: false,
    };
  },

  setup(props, { emit }) {
    const toast = useToast();
    const { route, router } = useRouter();
    const headerData = ref(LayoutData.header.data);
    const appInfo = ref();
    headerData.value.title = "Import hồ sơ";
    document.title =
      headerData.value.title + " | " + LayoutData.appInfo.data.appName;

    return {};
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
